// @flow
import type { Org as ApiOrg } from 'api/orgs';
import type { Action } from '../actions/orgs';

export type Org = {
  ...$Exact<ApiOrg>,
  isFetching: boolean
};

export type State = { byId: { [string]: Org } };

export default function orgs(state: State = { byId: {} }, action: Action) {
  switch (action.type) {
    case 'FETCH_ORG_REQUEST':
      return {
        byId: {
          ...state.byId,
          [action.orgId]: {
            ...state.byId[action.orgId],
            id: action.orgId,
            isFetching: true
          }
        }
      };
    case 'FETCH_ORG_SUCCESS':
      return {
        byId: {
          ...state.byId,
          [action.org.id]: {
            ...action.org,
            isFetching: false
          }
        }
      };
    case 'PARTIAL_UPDATE_ORG':
      return {
        byId: {
          ...state.byId,
          [action.values.id]: {
            ...state.byId[action.values.id],
            ...action.values
          }
        }
      };
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
